import {
    useAppStore,
    useTVStore,
    useVisibilityStore,
    useVODStore,
} from '@/shared/store'
import { useAnalytics } from '@/app/context/AnalyticsContext/AnalyticsContext'

export const useTopMenu = () => {
    const {
        setTvContentVisible,
        setVodContentVisible,
        setEpgContentVisible,
        setHomeContentVisible,
    } = useVisibilityStore()

    const { setActualPagePosition, setClearVod } = useVODStore()

    const { setWhatNextId } = useTVStore()

    const { setAssetType } = useAppStore()

    const Analytics = useAnalytics()
    const mainScreen = document.getElementById('MainScreen')

    const resetVodState = () => {
        setAssetType(null)
        setClearVod()
        setWhatNextId('')
        if (mainScreen) {
            mainScreen.style.backgroundImage = ''
        }
    }

    const handleHomeClick = () => {
        setHomeContentVisible()
        resetVodState()
        Analytics?.analyticsLogEvent('click_home')
    }

    const handleTvClick = () => {
        setTvContentVisible(true)
        resetVodState()
        Analytics?.analyticsLogEvent('click_tv')
    }

    const handleEpgClick = () => {
        setEpgContentVisible()
        resetVodState()
        Analytics?.analyticsLogEvent('click_epg')
    }

    const handleVodClick = (shouldResetState?: boolean) => {
        shouldResetState && resetVodState()
        setVodContentVisible()
        setActualPagePosition([])
        Analytics?.analyticsLogEvent('click_vod')
    }
    return { handleHomeClick, handleTvClick, handleEpgClick, handleVodClick }
}
